// extracted by mini-css-extract-plugin
export var border = "_l-8";
export var brand = "_l-t";
export var button = "_l-l";
export var center = "_l-a";
export var centered = "_l-6";
export var closeButton = "_l-c";
export var disabledWrapper = "_l-m";
export var error = "_l-p";
export var extraLarge = "_l-4";
export var extraSmall = "_l-1";
export var fill = "_l-i";
export var footer = "_l-h";
export var footerAction = "_l-j";
export var footerButtons = "_l-k";
export var header = "_l-7";
export var headerWithClose = "_l-d";
export var icon = "_l-o";
export var info = "_l-s";
export var inline = "_l-9";
export var large = "_l-3";
export var main = "_l-e";
export var modal = "_l-0";
export var nearFull = "_l-5";
export var neutral = "_l-u";
export var noPadding = "_l-g";
export var none = "_l-v";
export var scrollable = "_l-f";
export var small = "_l-2";
export var success = "_l-r";
export var tight = "_l-n";
export var titleIcon = "_l-b";
export var warn = "_l-q";